import { FC } from 'react';
import {
	Accordion,
	NumberInput,
	Badge,
	Text,
	NumberInputProps,
} from '@mantine/core';
import { useTypedDispatch, useTypedSelector } from '@/store/hooks';
import { creatorActions } from '@/store/slices/creatorSlice';
import { useContent } from '@/providers/ContentProvider';
import APP_CONFIG from '@/configs/appConfig';

const baseSlug = 'creator.';

export const ProductLength: FC = () => {
	const dispatch = useTypedDispatch();
	const { getContent } = useContent();

	const { product, length, options } = useTypedSelector((app) => app.creator);

	const handleChange: NumberInputProps['onChange'] = (value) => {
		dispatch(creatorActions.setLength(Number(value)));
	};

	return (
		<Accordion.Item value="product-length">
			<Accordion.Control
				disabled={!product || !options.maxLength}
				icon={
					!!length && (
						<Badge>
							<Text size="sm" fw="bold">
								{length} mm
							</Text>
						</Badge>
					)
				}
			>
				{getContent(`${baseSlug}fourthOption.name`)}
			</Accordion.Control>
			<Accordion.Panel>
				<Text mb="md">
					Na podstawie wybranego wariantu odpływu wyznaczyliśmy maksymalną
					długość odpływu: <strong>{options.maxLength} mm</strong>.
				</Text>
				<NumberInput
					suffix=" mm"
					w="100%"
					value={length}
					min={APP_CONFIG.LENGTH.MIN}
					max={options.maxLength}
					onChange={handleChange}
				/>
			</Accordion.Panel>
		</Accordion.Item>
	);
};
